module.exports = __webpack_public_path__ + "static/media/theMofG1.5c28e90f.png";